<div class="d-flex flex-column wrapper">
  <div class="impact-placeholder">
    <div class="impact">- % impact</div>
  </div>
  <div class="d-flex flex-column">
    <div class="d-flex flex-g1">
      <div class="circle">
        <div class="outer-circle">
          <div class="inner-circle">
            <div class="reach-data-placeholder">
              <span class="reach-placeholder">-</span>
              <span class="percent-placeholder"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row flex-auto align-items-center title-place">
      <span class="title">{{title}}</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-gauge-chart-placeholder/achoo-gauge-chart-placeholder.component.html